import { createFileRoute } from '@tanstack/react-router';
import { ClientsPage } from '../clients-page';
import { FeatureGate } from '../firm/feature-gate';
import { InquiriesCard } from '../firm/inquiries-card';
import { TableSearch } from '../table-search';

export const Route = createFileRoute('/inquiries')({
  // The table keeps its view in the address.
  validateSearch: TableSearch,
  component: Inquiries,
});

/** What prospective clients wrote through the firm's portal (ADR-023), with CHECK-POINT. */
function Inquiries() {
  return (
    <ClientsPage>
      <FeatureGate feature="check-point">
        <InquiriesCard />
      </FeatureGate>
    </ClientsPage>
  );
}
